import { TextChatUser } from '../xislivechat/models/text-chat-user';
import { Injectable } from '@angular/core';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { DynamicQueryObservable } from 'common/dynamicquery/dynamic-query-observable.model';

@Injectable()
export class TextChatUserService {

  constructor(private dynamicQuery: DynamicQueryAdapterService,
              private dynamicQueryDecorator: DynamicQueryDecoratorService) {
  }

  observeTextChatUserByTextUserId(textUserId): DynamicQueryObservable<TextChatUser> {
    if (!textUserId) {
      throw new Error('Missing textUserId');
    }

    const messagesObservable = this.dynamicQuery.getQuery('textChatUserByTextUserID', { TextUserID: textUserId });
    return this.dynamicQueryDecorator.create(messagesObservable, TextChatUser.wrap);
  }
}
